import getClassnameFromComponent from 'utils/getClassnameFromComponent';

/**
 * Get an element or NodeList from another component.
 *
 * @param {String}  className The classname to retrieve.
 * @param {String}  component The component from which to retrieve the classname.
 * @param {Boolean} all       Return a NodeList
 *
 * @return {HTMLElement|NodeList}
 */
export default function getElementFromComponent(className, component, all = false) { // eslint-disable-line max-len
  const componentClassname = getClassnameFromComponent(className, component);

  if (! componentClassname) {
    return null;
  }

  const element = (all)
    ? document.querySelectorAll(componentClassname)
    : document.querySelector(componentClassname);

  return element;
}
